import { InjectionToken } from '@angular/core';

export interface ApplicationInsightsConfig {
  connectionString: string;
  enableAutoRouteTracking?: boolean;
  disableTelemetry?: boolean;
}
export const APPLICATION_INSIGHTS_CONFIG =
  new InjectionToken<ApplicationInsightsConfig>(
    'Config for Application Insights'
  );
